import React from "react";
import { FilterSelector } from "../FilterSelector";
import { filterIds, producerOptions, searchfilterStateId as sfState, terms } from "../../../constants/suggestedAgents";
import PropTypes from 'prop-types';
import { searchTerms } from "../../../../constants";

export const NewProducers = ({
    inactivityDefault,
    newProdDefault,
    onInactivityChange,
    onNewProdChange,
    value,
    handleFilterChange,
    mlsOptions,
    selectedFilterValues,
    selectedMlsId,
}) => {

    return (
        <>
             <FilterSelector
                containerClass='mb-3'
                dataLwtId='select-producers-mls'
                defaultValue={mlsOptions.find(mls => mls.value === selectedMlsId)}
                labelText={searchTerms.mls}
                options={mlsOptions}
                onChange={(option) => handleFilterChange(option, filterIds.producers, sfState.mls)}
                value={mlsOptions.find(mls => mls.value === (selectedFilterValues?.mls?.value ?? selectedMlsId))}
            />
            <FilterSelector
                dataLwtId='select-producers-new-production'
                defaultValue={newProdDefault}
                labelText={`${terms.hasNewProductionOver}:`}
                options={producerOptions.newProd}
                onChange={onNewProdChange}
                value={value?.newProd}
            />
            <FilterSelector
                dataLwtId='select-producers-inactivity'
                defaultValue={inactivityDefault}
                labelText={`${terms.afterAnInactivityPeriodOf}:`}
                options={producerOptions.inactivity}
                onChange={onInactivityChange}
                value={value?.inactivity}
            />
        </>
    )
};

NewProducers.propTypes = {
    inactivityDefault: PropTypes.object,
    newProdDefault: PropTypes.object,
    onInactivityChange: PropTypes.func.isRequired,
    onNewProdChange: PropTypes.func.isRequired,
    value: PropTypes.object,
};
